"use strict";

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
}); //================================================================ 

/** @module std */
//================================================================

var Exception_1 = require("./Exception");
/**
 * Logic Error.
 *
 * @author Jeongho Nam <http://samchon.org>
 */


var LogicError =
/** @class */
function (_super) {
  __extends(LogicError, _super);
  /**
   * Initializer Constructor.
   *
   * @param message The error messgae.
   */


  function LogicError(message) {
    return _super.call(this, message) || this;
  }

  return LogicError;
}(Exception_1.Exception);

exports.LogicError = LogicError;
/**
 * Domain Error.
 *
 * @author Jeongho Nam <http://samchon.org>
 */

var DomainError =
/** @class */
function (_super) {
  __extends(DomainError, _super);
  /**
   * Initializer Constructor.
   *
   * @param message The error messgae.
   */


  function DomainError(message) {
    return _super.call(this, message) || this;
  }

  return DomainError;
}(LogicError);

exports.DomainError = DomainError;
/**
 * Invalid Argument Exception.
 *
 * @author Jeongho Nam <http://samchon.org>
 */

var InvalidArgument =
/** @class */
function (_super) {
  __extends(InvalidArgument, _super);
  /**
   * Initializer Constructor.
   *
   * @param message The error messgae.
   */


  function InvalidArgument(message) {
    return _super.call(this, message) || this;
  }

  return InvalidArgument;
}(LogicError);

exports.InvalidArgument = InvalidArgument;
/**
 * Length Error.
 *
 * @author Jeongho Nam <http://samchon.org>
 */

var LengthError =
/** @class */
function (_super) {
  __extends(LengthError, _super);
  /**
   * Initializer Constructor.
   *
   * @param message The error messgae.
   */


  function LengthError(message) {
    return _super.call(this, message) || this;
  }

  return LengthError;
}(LogicError);

exports.LengthError = LengthError;
/**
 * Out-of-range Exception.
 *
 * @author Jeongho Nam <http://samchon.org>
 */

var OutOfRange =
/** @class */
function (_super) {
  __extends(OutOfRange, _super);
  /**
   * Initializer Constructor.
   *
   * @param message The error messgae.
   */


  function OutOfRange(message) {
    return _super.call(this, message) || this;
  }

  return OutOfRange;
}(LogicError);

exports.OutOfRange = OutOfRange;
exports.logic_error = LogicError;
exports.domain_error = DomainError;
exports.invalid_argument = InvalidArgument;
exports.length_error = LengthError;
exports.out_of_range = OutOfRange;